import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'
import { Link } from 'react-router'
import { Icon, ToolTip } from '@driftt/tide-core-legacy'
import cx from 'classnames'


import { SEQUENCE_ENROLL_URL } from 'constants/ResourcesConstants'
import { getGoogleScopes } from 'app/modules/integrations/api'
import { GoogleScopes } from 'app/modules/integrations/constants'

import './style.styl'

class EnrollButtonConvo extends Component {
  state = {
    modalVisible: false,
    googleScopesFetched: false,
    googleScopes: [],
  }

   componendWillUnmount() {
     window.removeEventListener('message', this.messageEventHandler, false)
   }

   componentWillMount() {
     window.addEventListener('message', this.messageEventHandler, false)
     getGoogleScopes().then(this.receiveScopes)
   }

   messageEventHandler = (event) => {
    const frame = document.getElementById("contact-sequence-enroll-frame")
      if (event.source !== frame && !event.data.type) {
       return
     }
     if (event.data.type ==='@@driftext/hide_enroll_modal' ) {
       this.setState({
         modalVisible: false
       })
     }
   }

  receiveScopes = data => {
    this.setState({
      googleScopes: data,
      googleScopesFetched: true,
    })
  }

  handleButtonClick = () => {
    this.setState({ modalVisible: true })
  }

  handleCloseClick = () => {
    this.setState({
      modalVisible: false,
    })
  }

  render() {
    const { endUser } = this.props
    const { modalVisible, googleScopesFetched, googleScopes } = this.state

    const enrollEmail =  endUser.getIn(['email'], false) || endUser.getIn(['attributes', 'email'], false)


    if (!googleScopesFetched) {
      return (<div> </div>)
    }
    if ((!googleScopes.includes(GoogleScopes.READ) || !googleScopes.includes(GoogleScopes.SEND)) && enrollEmail) {
      return (
        <a href="/settings/email" target="_blank">
          <div className="contact-sidebar-enroll-button">
            <Icon name="email-send" width={30}/> Enroll
          </div>
        </a>)
    }

    return (
      <div>
        <ToolTip
          hover={!enrollEmail}
          flow={'up'}
          component={<div>You can&apos;t enroll someone who <br/> doesn&apos;t have an email address</div>}>
          <span className={cx('contact-sidebar-enroll-button', { 'contact-sidebar-enroll-button--disabled': !enrollEmail })} onClick={enrollEmail ? this.handleButtonClick : undefined}> <Icon name="email-send" width={20}/>Enroll</span>
        </ToolTip>
        {modalVisible &&
          <div className="contact-sequence-enroll-wrapper">
             <div className="contact-sequence-enroll">
              <iframe id="contact-sequence-enroll-frame" title="Enroll your sequence" src={`${SEQUENCE_ENROLL_URL}?email=${enrollEmail}`} />
            </div>
          </div>
        }
      </div>
    )
  }
}

export default EnrollButtonConvo



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/EnrollButtonConvo/index.js